






















































































































import Vue from "vue";
import { state } from "../data/state";
import EntityCounterItem from "./EntityCounterItem.vue";
import InfoTypeSection from "./InfoTypeSection.vue";
import { computed } from "@vue/composition-api";
import InsightsSection from "./InsightsSection.vue";
import { SharedState } from "@/common/state";
import { AppAnalytics } from "@/analytics";
import { AxisType } from "@/gql/types";
import { PopulationTypeHelper, POPULATION_TYPE } from "@/common/models";
import SummaryHeader from "./SummaryHeader.vue";
import InfoTrustSection from "./InfoTrustSection.vue";
import { InvEntityType } from "../data/model";
import files_handler from "../entities/files";
import { fixTier3XY } from "@/gql/cords";
import ClusterSummary from "./ClusterSummary.vue";
import Processing from "@/components/table/Processing.vue";
export default Vue.extend({
  components: {
    EntityCounterItem,
    InfoTypeSection,
    InsightsSection,
    SummaryHeader,
    InfoTrustSection,
    //  SubjectsBar,
    ClusterSummary,
    Processing,
  },
  setup() {
    const {
      current_subject,
      is_trust_relevant_for_entity,
      is_loading_counters,
      entity_counters,
      info_types_counters,
      relative_time_frame,
      has_previous_period,
      not_available,
      subjects,
    } = state;

    const { selectedTimeFrameDisplayName } = SharedState;

    const time_frame_str = computed(() =>
      selectedTimeFrameDisplayName.value.replace(/\((.+)\)/, "")
    );

    const show_info_types_section = computed(() => {
      const { type, id } = current_subject.value;
      if (type === "LABEL") {
        const isL0 = SharedState.allInfoTypes.value[id].generation === 0;
        // if it's L1 | L2 it should not be displayed
        return isL0;
      }
      return true;
    });

    const show_entities_modal = (type: InvEntityType) => {
      SharedState.ifIsPayingUser(
        () => {
          AppAnalytics.report({
            component: "Investigation",
            eventName: `Investigation_tier#2 summary tab entity's_click on sentence in activities summary`,
          });
          const type_for_restriction_check: POPULATION_TYPE = type.startsWith(
            "EMPLOYEE"
          )
            ? POPULATION_TYPE.EMPLOYEE
            : (type as POPULATION_TYPE);
          if (
            SharedState.restrictions.is_restricted_entity(
              type_for_restriction_check
            )
          ) {
            SharedState.restrictions.show_restrictions_modal(
              "entity",
              PopulationTypeHelper.asString(type_for_restriction_check, true)
            );
            return;
          }

          state.on_count_clicked(type);
        },
        { premium_modal_key: "forensics-popup-2024" }
      );
    };

    const show_files_for_info_selected_info_type = (label: {
      id: string;
      name: string;
    }) => {
      SharedState.ifIsPayingUser(
        () => {
          const { code } = SharedState.getInfoType(label.id)!;
          if (SharedState.restrictions.is_restricted_info(code)) {
            SharedState.restrictions.show_restrictions_modal(
              "info",
              label.name
            );
            return;
          }
          const { type, from } = SharedState.selectedTimeFrameOption.value;
          files_handler.show_modal(
            current_subject.value,
            [
              fixTier3XY({
                x: {
                  type: AxisType.ContentLabel,
                  values: [label.id],
                },
                y: {
                  type: PopulationTypeHelper.asAxisType2(
                    current_subject.value.type,
                    "both"
                  ),
                  values: [current_subject.value.id],
                },
                z: {
                  type,
                  values: [from],
                },
              }),
            ],
            {
              label: label.name,
              hide_filters: ["info_types"],
            }
          );
        },
        { premium_modal_key: "forensics-popup-2024" }
      );
    };

    return {
      show_subjects_bar: computed(() => Object.keys(subjects.value).length > 1),
      info_types_counters,
      relative_time_frame_str: computed(() =>
        relative_time_frame.value.displayName.replace(/\(.*\)/, "")
      ),
      has_previous_period,
      not_available_display_title: not_available.title,
      not_available_display_msg: not_available.msg,
      current_subject,
      entity_counters,
      time_frame_str,
      show_entities_modal,
      is_loading_counters,
      show_info_types_section,
      show_information_trust_section: computed(() =>
        is_trust_relevant_for_entity(current_subject.value)
      ),
      show_files_for_info_selected_info_type,
      is_data_not_available: computed(
        () => !SharedState.is_data_available.value
      ),
    };
  },
});
